import { faker } from "@faker-js/faker/locale/fr"
import { SourceName } from "../../../types"
import type { ApiFinancialDataStocks } from "../../stocks"

export const stocksMock = (): ApiFinancialDataStocks => {
  const {
    number: { int },
    date,
    datatype: { boolean },
  } = faker
  const num = (min = 0, max = 999_999) => int({ min, max })
  const fakeDate = () => date.anytime().toISOString().split("T")[0] // YYYY-MM-DD
  const maybeNull = <T>(value: T): T | null => (boolean() ? value : null)

  const mockStock = () => ({
    volume: maybeNull(num(0, 10_000)),
    nbDaysVolume: maybeNull(num(1, 365)),
    valueHt: maybeNull(num(0, 500_000)),
    valueTtc: maybeNull(num(0, 600_000)),
    nbDaysValueTtc: maybeNull(num(1, 365)),
  })

  const minDays = num(0, 250)
  const maxDays = num(minDays, 500)

  const goodVatRates = Array.from({ length: 4 }).map((_) => ({
    vatRate: String(num(0, 50)),
    norm: maybeNull({ minDays, maxDays }),
    uppStockAverage: maybeNull(num(0, 1000)),
    ...mockStock(),
  }))

  const badVatRates = [
    { vatRate: "2.1", ...mockStock() },
    { vatRate: "5.5", ...mockStock() },
    { vatRate: "20 %", ...mockStock() },
    { vatRate: "10", ...mockStock() },
    { vatRate: null, ...mockStock() },
    { vatRate: "20", ...mockStock() },
  ]

  return {
    adherentId: int({ min: 1, max: 999_999 }),
    laboratoryId: int({ min: 1, max: 999_999 }),
    periodEndDate: fakeDate(),
    stock: mockStock(),
    stockPerVatRate: boolean(0.75) ? goodVatRates : badVatRates,
    sources: faker.helpers.arrayElements(Object.values(SourceName), {
      min: 1,
      max: 3,
    }),
  }
}
